export default __webpack_public_path__ + "static/media/about.d00f2e2c.jpg";